import { MutationTree } from 'vuex';
import { ISessionState } from '@signing-page/session/store/session.store';
import { IAuthenticationStep } from '@signing-page/authentication/types/authentication-step';
import { IAuthenticationStepInput } from '@signing-page/authentication/types/authentication-step-input';
import { IToken } from '@signing-page/session/type/token';
import { EDocumentStatus } from '@signing-page/documents/types/enums/document-status';

export const mutationSetToken = 'setToken';
export const mutationSetError = 'setError';
export const mutationSetStatus = 'setStatus';
export const mutationSetAuthenticationSteps = 'setAuthenticationSteps';
export const mutationSetAuthenticationAnswers = 'setAuthenticationAnswers';
export const mutationVerifySms = 'verifySms';
export const mutationSetSubmittingResponse = 'setSubmittingResponse';
export const mutationSetSendPinRetryCount = 'setSendPinRetryCount';
export const mutationSetRecipientFirstOpen = 'setRecipientFirstOpen';

export const mutations: MutationTree<ISessionState> = {
  [mutationSetToken](state: ISessionState, token: IToken) {
    state.token.jwt = token.jwt;
    state.token.exp = token.exp;
    state.recipientFirstOpen = token.metaData ? token.metaData.isFirstVisit : true;
  },
  [mutationSetAuthenticationSteps](state: ISessionState, steps: IAuthenticationStep[]) {
    state.authentication.steps = steps;
  },
  [mutationSetError](state: ISessionState, error: boolean) {
    state.error = error;
  },
  [mutationSetAuthenticationAnswers](state: ISessionState, answers: IAuthenticationStepInput[]) {
    state.authentication.answers = answers;
  },
  [mutationSetStatus](state: ISessionState, status: EDocumentStatus) {
    state.status = status;
  },
  [mutationVerifySms](state: ISessionState, verified: boolean) {
    state.isCorrectPin = verified;
  },
  [mutationSetSubmittingResponse](state: ISessionState, submitting: boolean) {
    state.authentication.submittingResponse = submitting;
  },
  [mutationSetSendPinRetryCount](state: ISessionState, retryCount: number) {
    state.sendPinRetryCount = retryCount;
  },
  [mutationSetRecipientFirstOpen](state: ISessionState, value: boolean) {
    state.recipientFirstOpen = value;
  },
};
